export const CloseIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg
    fill="none"
    viewBox="-4 -4 24 24"
    role="presentation"
    width={size}
    height={size}
  >
    <path
      fill={color}
      d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"
    ></path>
  </svg>
);
